import { ui } from '../../styles/ui'

export default function Input({ as = 'input', className = '', ...props }) {
  const baseClass = as === 'textarea' ? ui.forms.textarea : ui.forms.input

  if (as === 'textarea') {
    return <textarea className={`${baseClass} ${className}`.trim()} {...props} />
  }

  return <input className={`${baseClass} ${className}`.trim()} {...props} />
}
